import { React } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { useTheme } from '../../../Context/ThemeContext';

import NoticeInfo from './NoticeInfo';

const NoticeList = (props) => {
  const { data } = props;

  const { isDark } = useTheme();
  const history = useHistory();

  function clickDetailsFn(index) {
    history.push('/notice/details/' + data[index].noticeId);
  }
  
  return (
    <TopLevelWrapper isDark={isDark}>
      <TotalView>
        {
          data.map((data, index) => (
            <NoticeInfo key={index} data={data} index={index} clickFn={clickDetailsFn}/>
          ))
        }
      </TotalView>
    </TopLevelWrapper>
  )
}

export default NoticeList;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 1020px;
  height: 428px;

  margin-top: 28px;
  margin-bottom: 44px;

  border-radius: 30px;
  box-shadow: ${props => props.isDark ? 'none' : '0px 40px 50px rgba(240, 232, 227, 0.5)'};
  background-color: ${props => props.theme.subBackground};
`;

const TotalView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 4px;

  width: 980px;
  height: 380px;
`;
